module.exports = __webpack_public_path__ + "assets/img/logo_white.e7c1c19a.svg";